export default function Table(theme) {
  return {
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: 'transparent',
          borderBottom: '1px solid #21293B',
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {},
        head: {
          backgroundColor: 'transparent',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: 'none',
          padding: theme.spacing(1, 0),
        },
        head: {
          color: theme.palette.text.secondary,
          paddingBottom: theme.spacing(1),
        },
        stickyHeader: {
          backgroundColor: theme.palette.background.paper,
          backgroundImage: `linear-gradient(to bottom, ${theme.palette.background.neutral} 0%, ${theme.palette.background.neutral} 100%)`,
        },
        body: {},
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        root: {
          borderTop: `solid 1px ${theme.palette.divider}`,
        },
        toolbar: {
          height: 64,
        },
        select: {
          '&:focus': {
            borderRadius: theme.shape.borderRadius,
          },
        },
        selectIcon: {
          width: 20,
          height: 20,
          marginTop: 2,
        },
      },
    },
  };
}
